import React from 'react';
import Typography from '@mui/material/Typography';
import stylesConfig from '../../../../theme/config';

function HeadingVerySmall({
  text, cy, children, sx,
}) {
  return (
    <Typography
      component="h6"
      variant="h6"
      data-cy={cy}
      sx={{
        font: stylesConfig.typography.headingVerySmall.font,
        letterSpacing: stylesConfig.typography.headingVerySmall.letterSpacing,
        marginBottom: '1rem',
        ...sx,
      }}
    >
      {children}
      {text}
    </Typography>
  );
}

HeadingVerySmall.defaultProps = {
  cy: 'heading-large',
  sx: undefined,
};

export default HeadingVerySmall;
